import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";
// Icons can be added via toastOptions.icon if we later want per-variant branding.

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      position="top-center"
      className="toaster group"
      duration={2000}
      visibleToasts={2}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background/95 group-[.toaster]:backdrop-blur-sm group-[.toaster]:text-foreground group-[.toaster]:border-primary/20 group-[.toaster]:shadow-xl group-[.toaster]:shadow-primary/10 group-[.toaster]:rounded-2xl",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:rounded-full",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:rounded-full",
          success: "group-[.toaster]:border-primary/30 group-[.toaster]:text-primary",
          error: "group-[.toaster]:border-destructive/30 group-[.toaster]:bg-destructive/10 group-[.toaster]:text-destructive",
          info: "group-[.toaster]:border-primary/20",
        },
      }}
      // Keep toasts clear of the sticky header (h-14) + safe-area inset.
      offset="calc(1rem + env(safe-area-inset-top) + 3.5rem)"
      {...props}
    />
  );
};

export { Toaster, toast };
